module.exports = __webpack_public_path__ + "static/pepeone-6217e73fbf7ec0d69b7e883691965bdd.png";